import { AddGameDialogComponent } from './add-game-dialog.component';
import { EditGameDialogComponent } from './edit-game-dialog.component';
import { EditPlaylistDialogComponent } from './edit-playlist-dialog.component';
import { ImportEventsDialogComponent } from './import-events-dialog.component';
import { AddPlaylistDialogComponent } from './add-playlist-dialog.component';
import { AddToPlaylistDialogComponent } from './add-to-playlist-dialog.component';

export const dialogs: any[] = [
  AddGameDialogComponent,
  EditGameDialogComponent,
  EditPlaylistDialogComponent,
  ImportEventsDialogComponent,
  AddPlaylistDialogComponent,
  AddToPlaylistDialogComponent
];

export * from './add-game-dialog.component';
export * from './edit-game-dialog.component';
export * from './edit-playlist-dialog.component';
export * from './import-events-dialog.component';
export * from './add-playlist-dialog.component';
export * from './add-to-playlist-dialog.component';
